<script lang="ts">
	import { afterNavigate } from '$app/navigation';
	import { PUBLIC_YOTPO_PRODUCT_ID } from '$env/static/public';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLElement> {
		hideHeadline?: boolean;
		imageUrl?: string;
		productUrl?: string;
	}

	let {
		imageUrl = 'https://cdn-yotpo-images-production.yotpo.com/Product/674516854/566668571/original.png',
		productUrl = 'https://mill.com/food-recycler',
		hideHeadline = false
	}: Props = $props();

	afterNavigate(() => {
		if (document.getElementById('yotpo-widget-script')) {
			window.yotpoWidgetsContainer?.initWidgets();
			return;
		}

		const script = document.createElement('script');
		script.defer = true;
		script.src =
			'https://cdn-widgetsrepository.yotpo.com/v1/loader/j8GVSlElOAuRUbkGvDkd2D8UH17wOdeAsjtVDvKJ';
		script.id = 'yotpo-widget-script';

		document.body.appendChild(script);
	});
</script>

<section id="reviews-widget" class={['max-lg:pb-10', { 'pt-12 lg:pt-[120px]': !hideHeadline }]}>
	{#if !hideHeadline}
		<h1 class="text-center text-[32px]/[100%] font-semibold text-brown-1 lg:text-[48px]/[110%]">
			Mill Customer Reviews
		</h1>
	{/if}
	<div
		class="yotpo-widget-instance"
		data-yotpo-instance-id="729119"
		data-yotpo-product-id={PUBLIC_YOTPO_PRODUCT_ID}
		data-yotpo-name="Mill food recycler"
		data-yotpo-url={productUrl}
		data-yotpo-image-url={imageUrl}
		data-yotpo-price="999"
		data-yotpo-currency="$"
		data-yotpo-description="Mill food recycler"
	></div>
</section>

<style>
	:global(#yotpo-mobile-filters-popup) {
		z-index: 100;
	}
</style>
